// Define words to be added at specific timestamps (in seconds)
export const TIMESTAMPED_WORDS = [
  { time: 19, word: 'hello' },
  { time: 20, word: 'me' },
  { time: 21.5, word: 'adrian-namesign' },
  { time: 22.6, word: 'wonderful' },
  { time: 23.6, word: 'meet' },
  { time: 24.3, word: 'you' },
  { time: 26, word: 'me' },
  { time: 27.4, word: 'excited' },
  { time: 28.3, word: 'because' },
  { time: 29.5, word: 'now' },
  { time: 30, word: 'with' },
  { time: 30.9, word: 'this' },
  { time: 32, word: '#AI' },
  { time: 33, word: 'technology' },
  { time: 34, word: 'possible' },
  { time: 35, word: 'do' },
  { time: 36.9, word: '#ASL' },
  { time: 38, word: 'english' },
  { time: 39, word: 'interpreting' },
  { time: 39.6, word: 'in' },
  { time: 41, word: 'real-time' },
  { time: 42.7, word: 'with' },
  { time: 43.7, word: 'this' },
  { time: 45, word: 'technology' },
  { time: 46, word: 'we' },
  { time: 46.5, word: 'can' },
  { time: 47.3, word: 'make' },
  { time: 48.5, word: 'communication' },
  { time: 49.2, word: 'accessible' },
  { time: 50.2, word: 'affordable' },
  { time: 51.6, word: 'and' },
  { time: 52.6, word: 'available' },
  { time: 54, word: 'anytime' },
  { time: 56, word: 'anywhere' }
];

// words: the raw recognized sequence you expect
// translation: what to speak once that sequence completes
export const PATTERNS = [
    
    // 1) "My name is Adrian"
    {
        words: ['me', 'adrian-namesign'],
        translation: "My name is Adrian"
    },
    {
          words: ['me', 'not', 'adrian-namesign'],
          translation: "My name is Adrian"
    },
    {
          words: ['me', 'adrian-namesign', 'not'],
          translation: "My name is Adrian"
    },
    
    // 2) "Wonderful to meet you."
    {
      words: ['wonderful', 'meet', 'you'],
      translation: "Wonderful to meet you."
    },

    {
        words: ['wonderful', 'language', 'you'],
        translation: "Wonderful to meet you."
    },

    {
        words: ['wonderful', 'language', 'meet', 'you'],
        translation: "Wonderful to meet you."
    },

    {
        words: ['wonderful', 'meet', 'language', 'you'],
        translation: "Wonderful to meet you."
    },
    
    // 3) "I'm Deaf."
    {
      words: ['me', 'deaf'],
      translation: "I'm Deaf."
    },
  
    // 4) "I teach ASL at Douglas College."
    //    (ASL: me teach #ASL student over-there college)
    {
      words: ['me', 'teach', '#ASL', 'student', 'over-there', 'college'],
      translation: "I teach ay ess el to students in college."
    },

    {
        words: ['me', 'teach', 'student', '#ASL', 'over-there', 'college'],
        translation: "I teach ay ess el to students in college."
    },

    {
        words: ['me', 'teach', 'student', '#ASL', 'college'],
        translation: "I teach ay ess el to students in college."
    },
  
    // 5) "I'm excited"
    //    (ASL: me excited)
    {
      words: ['me', 'excited'],
      translation: "I'm excited"
    },
  
    // 6) "Now with this AI technology, it's possible to do ASL - English interpreting in real-time."
    //    (ASL: now with this #AI technology, possible do #ASL english interpreting in real-time)
    {
      words: ['because', 'now', 'with', 'this'],
      translation: "because now with this"
    },

    {
        words: ['#AI'],
        translation: "A.I."
    },
    
    {
        words: ['possible', 'do'],
        translation: "it's possible to do"
    },

    {
        words: ['#ASL'],
        translation: "A.S.L."
    },

    {
        words: ['english', 'interpreting'],
        translation: "to English interpreting"
    },

    {
        words: ['in', 'real-time'],
        translation: "in real-time"
    },
  
    // 7) "Finally, ASL will be equal to spoken languages in technology!"
    //    (ASL: finally #ASL will #BE tie-equal to speak language in technology!)
    {
      words: ['#ASL', 'will', '#BE', 'tie-equal'],
      translation: "ay ess el will be equal"
    },

    {
        words: ['to', 'speak', 'language', 'in', 'technology'],
        translation: "to spoken languages through technology!"
    },
  
    // 8) "Language is connection."
    //    (ASL: language is_are_real connection)
    {
      words: ['language', 'is_are_real', 'connection'],
      translation: "Language is connection."
    },
  
    // 9) "Communication is human."
    //    (ASL: communication is_are_real human)
    {
      words: ['communication', 'is_are_real', 'human'],
      translation: "Communication is human."
    },
  
    // 10) "No one should be not included because of cost or availability."
    //     (ASL: no one should #BE not include because #OF cost #OR availability)
    {
      words: ['no', 'one', 'should', '#BE', 'not', 'include'],
      translation: "No one should be excluded"
    },

    {
        words: ['because', '#OF', 'cost', '#OR', 'availability'],
        translation: "because of cost or availability."
    },
  
    // 11) "With this technology, we can make communication accessible, affordable, and available anytime, anywhere."
    //     (ASL: with this technology we can make communication accessible affordable and available anytime anywhere)

    {
        words: ['with', 'this', 'technology'],
        translation: "With this technology"
    },

    {
        words: ['we', 'can', 'make', 'communication'],
        translation: "we can make communication"
    },

    {
        words: ['accessible', 'affordable', 'and', 'available'],
        translation: "accessible, affordable, and available"
    },

    {
        words: ['anytime', 'anywhere'],
        translation: "anytime, anywhere"
    }
];
  
/**
 * Checks if the beginning of `buffer` exactly matches the sequence in `words`.
 */
function startsWithPattern(buffer, words) {
    if (buffer.length < words.length) return false;
    for (let i = 0; i < words.length; i++) {
      if (buffer[i] !== words[i]) return false;
    }
    return true;
}
  
  /**
   * Attempts to consume as many complete patterns as possible from the start
   * of `wordBuffer`. If a pattern is matched, it calls `speakFn` with that 
   * pattern's translation and removes those words from the buffer.
   *
   * If the start of the buffer doesn't match a pattern fully, but also isn't
   * even the *start* of any pattern, we speak just the first word and remove it.
   *
   * This process repeats until:
   *   1. No words remain
   *   2. Or the buffer might still match the start of some pattern 
   *      (but not fully), so we wait for more words next time.
   *
   * This function mutates `wordBuffer` in place.
   */
export function processWordBuffer(wordBuffer, patterns, speakFn) {
    // Keep looping until we can no longer reduce the buffer
    while (wordBuffer.length > 0) {
      // 1) Check if we fully match any pattern from the beginning
        const matchedPattern = patterns.find(ptn =>
            startsWithPattern(wordBuffer, ptn.words)
        );
      
        if (matchedPattern) {
            // Remove the matched words
            wordBuffer.splice(0, matchedPattern.words.length);
            // Speak the coherent translation
            speakFn(matchedPattern.translation);
            // Continue the loop — maybe more patterns can match immediately after
            continue;
        }
      
        // 2) If we did NOT match a pattern, check if the first word
        //    could still be the start of some pattern
        const couldBeStart = patterns.some(
        ptn => ptn.words[0] === wordBuffer[0]
        );
        
        if (!couldBeStart) {
        // The first word can't ever complete a pattern, so speak it individually
        const wordToSpeak = wordBuffer.shift(); // remove it
        speakFn(wordToSpeak);
        // keep looping (maybe the next word is the start of a pattern)
        continue;
        }
        
        // 3) Otherwise, we *might* be in the middle of building a pattern,
        //    so break to wait for more words in the future
        break;
    }
}

/**
 * Checks if the current buffer could potentially match any pattern in the future.
 * 
 * @param {Array} wordBuffer - The current buffer of words
 * @param {Array} patterns - The patterns to check against
 * @returns {boolean} - True if the buffer could potentially match a pattern
 */
export function couldFormPattern(wordBuffer, patterns) {
  if (wordBuffer.length === 0) return false;
  
  return patterns.some(pattern => {
    // Check if the current buffer is a prefix of this pattern
    for (let i = 0; i < Math.min(wordBuffer.length, pattern.words.length); i++) {
      if (wordBuffer[i] !== pattern.words[i]) {
        return false; // Mismatch found, can't match this pattern
      }
    }
    
    // If we've reached this point and the buffer is shorter or equal to the pattern,
    // then it's a potential match (it's a prefix of the pattern)
    return wordBuffer.length <= pattern.words.length;
  });
}